import axios from "axios";

import queryString from "query-string";
import { store, refreshAccessToken } from "@redux";
import { performLogoutActions } from "../Utilities/logoutUtils";
import { PATH_LOGIN } from "@routes";

const ftApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL_V2,

    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

ftApiClient.interceptors.request.use((config) => {
    const state = store.getState();
    config.headers.Authorization = `Bearer ${state.auth?.jwt?.accessToken}`;
    return config;
});

let isRefreshing = false;
let failedQueue: Array<{
    resolve: (value?: unknown) => void;
    reject: (reason?: any) => void;
}> = [];

const processQueue = (error: any = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });
    failedQueue = [];
};

ftApiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest.headers.__isRetry) {
            if (isRefreshing) {
                // Queue the failed request
                return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                    .then(() => {
                        return ftApiClient(originalRequest);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            } else {
                isRefreshing = true;
                originalRequest.headers.__isRetry = true;

                try {
                    const state = store.getState();
                    const userId = state.account.account.id;
                    await store.dispatch(
                        refreshAccessToken({
                            refreshToken: state.auth?.jwt?.refreshToken, 
                            userId,
                        })
                    ).unwrap();
                    
                    // Process all queued requests
                    processQueue();
                    isRefreshing = false;
                    
                    // Retry the original request
                    return ftApiClient(originalRequest);
                } catch (err) {
                    console.error("Error refreshing token:", err);
                    await performLogoutActions();
                    console.info("Redirecting to login page...");
                    window.location.href = PATH_LOGIN;
                    failedQueue = [];
                    isRefreshing = false;
                    return Promise.reject(err);
                }
            }
        }

        return Promise.reject(error);
    }
);

export default ftApiClient;
